module.exports = __webpack_public_path__ + "img/window-in-a-window.2489d9f2.svg";